// import ua from '../../plugins/userAgent.js';


// const el = document.querySelector(".top-articleLink")

// var x = 0
// var y = 0

// var mx = 0
// var my = 0

// var s = 0


// function maskLink() {
//   requestAnimationFrame(maskLink.bind(this));
  
//   var v = document.querySelector(".top-articleLink").getBoundingClientRect()

//   x += ((mx) - x) * 0.1;
//   y += ((my - v.y) - y) * 0.1;

//   if(x > 0 && y > 0) {
//     s = s < 1 ? s + 0.1 : 1
//   } else {
//     s = s > 0 ? s - 0.1 : 0
    
//   }
//   document.querySelector(".top-articleLink-back").style.setProperty('--circularwindow-scale', `${s}`);
//   document.querySelector(".top-articleLink-back").style.setProperty('--circularwindow-X', `${x}`);
//   document.querySelector(".top-articleLink-back").style.setProperty('--circularwindow-Y', `${y}`);

// }
// if(ua.getDevice() == "pc") {
//   maskLink()
// }

// // console.log(ua.getDevice())

// document.addEventListener('mousemove', (e) => {
//   mx = e.clientX
//   my = e.clientY
// });